module.exports = __webpack_public_path__ + "img/f7_en.45ccff2d.svg";